export const StudioImage = ({ name, alt = "", className = "", sizes = "100vw", eager = false }) => (
  <img
    src={`/images/${name}-640.webp`}
    srcSet={`/images/${name}-640.webp 640w, /images/${name}-1264.webp 1264w`}
    sizes={sizes}
    alt={alt}
    loading={eager ? "eager" : "lazy"}
    decoding="async"
    className={className}
  />
);
